import * as types from '../../index';

export const certificatesListAction = (data) => {
    return {
    type: types.CERTIFICATES_LIST,
    data
    }
};

export const expiringCertificateTitleAction = (data) => {
    return {
    type: types.EXPIRING_CERTIFICATE_TITLE,  
    data
    }
};

